import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const usePermissionStore = defineStore('permissionStore', () => {
  const permissionsData = reactive({
    //students
    viewStudents: { super: true, admin: true, teacher: true, staff: true, student: true },
    addStudents: { super: true, admin: true, teacher: true, staff: true, student: false },
    editStudents: { super: true, admin: true, teacher: true, staff: true, student: true },
    deleteStudents: { super: true, admin: true, teacher: true, staff: true, student: true },
    //classes
    viewClasses: { super: true, admin: true, teacher: false, staff: false, student: false },
    addClasses: { super: true, admin: true, teacher: true, staff: false, student: false },
    editClasses: { super: true, admin: true, teacher: false, staff: false, student: false },
    deleteClasses: { super: true, admin: true, teacher: false, staff: false, student: false },
    //school
    viewSchool: { super: true, admin: true, teacher: false, staff: false, student: false },
    addSchool: { super: true, admin: true, teacher: false, staff: false, student: true },
    editSchool: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteSchool: { super: true, admin: true, teacher: false, staff: false, student: false },
    //building
    viewBuildings: { super: true, admin: true, teacher: false, staff: false, student: false },
    addBuildings: { super: true, admin: true, teacher: false, staff: false, student: true },
    editBuildings: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteBuildings: { super: true, admin: true, teacher: false, staff: false, student: false },
    //staff
    viewStaff: { super: true, admin: true, teacher: false, staff: false, student: false },
    addStaff: { super: true, admin: true, teacher: false, staff: false, student: true },
    editStaff: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteStaff: { super: true, admin: true, teacher: false, staff: false, student: false },
    //department
    viewDepartment: { super: true, admin: true, teacher: false, staff: false, student: false },
    addDepartment: { super: true, admin: true, teacher: false, staff: false, student: true },
    editDepartment: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteDepartment: { super: true, admin: true, teacher: false, staff: false, student: false },
    //rooms
    viewRoom: { super: true, admin: true, teacher: false, staff: false, student: false },
    addRoom: { super: true, admin: true, teacher: false, staff: false, student: true },
    editRoom: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteRoom: { super: true, admin: true, teacher: false, staff: false, student: false },
    //schedule
    viewSchedule: { super: true, admin: true, teacher: false, staff: false, student: false },
    addSchedule: { super: true, admin: true, teacher: false, staff: false, student: true },
    editSchedule: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteSchedule: { super: true, admin: true, teacher: false, staff: false, student: false },
    //material/equipment
    viewMaterial: { super: true, admin: true, teacher: false, staff: false, student: false },
    addMaterial: { super: true, admin: true, teacher: false, staff: false, student: true },
    editMaterial: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteMaterial: { super: true, admin: true, teacher: false, staff: false, student: false },
    //School Year
    viewSchoolYear: { super: true, admin: true, teacher: false, staff: false, student: false },
    addSchoolYear: { super: true, admin: true, teacher: false, staff: false, student: true },
    editSchoolYear: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteSchoolYear: { super: true, admin: true, teacher: false, staff: false, student: false },
    //semester
    viewSemester: { super: true, admin: true, teacher: false, staff: false, student: false },
    addSemester: { super: true, admin: true, teacher: false, staff: false, student: true },
    editSemester: { super: true, admin: true, teacher: false, staff: false, student: true },
    deleteSemester: { super: true, admin: true, teacher: false, staff: false, student: false },
    //attendance
    viewAttendance: { super: true, admin: true, teacher: false, staff: false, student: false },
    editAttendance: { super: true, admin: true, teacher: false, staff: false, student: false },
    //reports
    viewReports: { super: true, admin: true, teacher: false, staff: false, student: false },
    generateReports: { super: true, admin: true, teacher: false, staff: false, student: false },
  });

  const checkPermission = (permission, role) => {
    // console.log(permissionsData)
    return permissionsData[permission]?.[role] || false;
  };

  const getRolePermissions = (role) => {
    const filteredPermissions = {};
    for (const permission in permissionsData) {
      filteredPermissions[permission] = permissionsData[permission][role];
    }
    return filteredPermissions;
  };

  const updateTeacherPermissions = (updatedPermissions) => {
    for (const permission in updatedPermissions) {
      if (permissionsData[permission]) {
        permissionsData[permission].teacher = updatedPermissions[permission];
      }
    }
  };
 // for updating
  const updateAllPermissions = (newPermissions) => {
    permissionsData = newPermissions; // Replace entire permissions data
  };

  return { permissionsData, checkPermission , getRolePermissions, updateTeacherPermissions, updateAllPermissions};
});


